interface ColorPickerProps {
  value: string;
  onChange: (value: string) => void;
  allowTransparent?: boolean;
}

export function ColorPicker({ value, onChange, allowTransparent = true }: ColorPickerProps) {
  const transparent = value === "transparent";
  return (
    <div className="color-picker-control">
      <input
        type="color"
        value={transparent ? "#ffffff" : value}
        disabled={transparent}
        onChange={(event) => onChange(event.target.value)}
      />
      {allowTransparent ? (
        <button
          type="button"
          className="button button--secondary button--compact"
          aria-pressed={transparent}
          onClick={() => onChange(transparent ? "#ffffff" : "transparent")}
        >
          {transparent ? "Use color" : "Transparent"}
        </button>
      ) : null}
    </div>
  );
}
